import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Typography } from '@material-ui/core';
import { BackdropCircular, Breadcrumb } from 'components';
import {getMarketingSegmentsQuoteQueueApi, getFailedMarketingSegmentsQuoteQueueApi} from 'api';
import QuotesQueueProgress from './QuotesQueueProgress';
import heroImg from './heroImg.svg';


const QuoteQueuePage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const {
    marketingSegmentsQuoteQueue,
    loadingMarketingSegmentsQueue,
    loadingFailedQueueTasks
  } = useSelector((state: IReduxState) => state.quote);

  useEffect(() => {
    getMarketingSegmentsQuoteQueueApi({dispatch});
  }, []);

  useEffect(() => {
    getFailedMarketingSegmentsQuoteQueueApi({dispatch, pageSize: rowsPerPage, page: currentPage});
  }, [currentPage, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };


  return (
    <div className="flex-grow flex-column relative h-full scroll-y pb-5">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Quotes Queue' }
          ]}
        />
      </div>
      <div className="flex-column items-center justify-center">
        {marketingSegmentsQuoteQueue.length ?
          <QuotesQueueProgress
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
          />
          :
          <>
            <img src={heroImg} className="p-5" />
            <Typography className="h5 text-muted p-3">All quotes are created. No quotes in queue.</Typography>
            <Button
              color="primary"
              variant="contained"
              onClick={() => history.push('/quoting')}
              className="uppercase px-5 mt-4"
            >
              Create Quote
            </Button>
          </>
        }
      </div>
      <BackdropCircular loading={loadingMarketingSegmentsQueue || loadingFailedQueueTasks} />
    </div>
  );
};

export default QuoteQueuePage;
